var MealHoliday = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = opts || {};
    this.init();
};
MealHoliday.prototype = {
    constructor: MealHoliday,
    $el: undefined,
    options: undefined,
    buttonTpl: undefined,
    compiledButtonTpl: undefined,
    init: function() {
        var self = this;
        self.buttonTpl = document.querySelector('#action_button').innerHTML;
        self.$el.on('click', 'a', function(evt) {
            evt.preventDefault();
            self.handleAction(evt.currentTarget);
            return false;
        });
    },
    handleAction: function($el) {
        var self = this;
        // var $el = $(el);
        var url = $el.href;
        let currentAction = url.match(/\/activate\/?$/) ? 'a' : 'd';
        let id = parseInt(url.match(/\/admin\/meals\/holidays\/(\d+)/)[1]);
        $.get(url).done(function(response) {
            let $parent = $($el.closest('td'));
            $($el.closest('tr')).find('td:nth-child(2)').html(currentAction == 'a' ? 'Active' : '');
            $el.remove();
            $parent.append(self.renderButton({
                id: id,
                actionLower: currentAction == 'a' ? 'deactivate' : 'activate',
                btnStyle: currentAction == 'a' ? 'outline-danger' : 'secondary',
                action: currentAction == 'a' ? 'Deactivate' : 'Activate'
            }));
        });
    },
    renderButton: function(data) {
        var self = this;
        if (!self.compiledButtonTpl) {
            self.compiledButtonTpl = _.template(self.buttonTpl);
        }
        return self.compiledButtonTpl(data);
    }
};

module.exports = MealHoliday;